import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
let UserSezionaleModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('boolean'), _dec4 = attr('string'), _dec5 = belongsTo('contact', {
  inverse: 'user_sezionales',
  async: false
}), _dec6 = attr('boolean', {
  defaultValue: false
}), _class = class UserSezionaleModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "prefix", _descriptor, this);
    _initializerDefineProperty(this, "suffix", _descriptor2, this);
    _initializerDefineProperty(this, "is_default", _descriptor3, this);
    _initializerDefineProperty(this, "xml_document_type", _descriptor4, this);
    _initializerDefineProperty(this, "contact", _descriptor5, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor6, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "prefix", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "suffix", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "is_default", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "xml_document_type", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "contact", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { UserSezionaleModel as default };
//# sourceMappingURL=user-sezionale.js.map
